var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"px-0",attrs:{"fluid":""}},[_c('div',{staticClass:"profile-page"})])
}
var staticRenderFns = []

export { render, staticRenderFns }